module.exports = "<li> <a href=# class=\"action-link {%- cls %} {% if (disabled) { %} disabled {% } %}\"> <i class=\"fa fa-{%- icon %}\" aria-hidden=true></i> {%- title %} </a> </li>";


//////////////////
// WEBPACK FOOTER
// ./src/components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html
// module id = 27
// module chunks = 1